import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/images/logo.png";

const Header = () => {
	return (
		<header className='hd'>
			<div className='container'>
				<Link to='/' className='hd-logo' aria-label='Home'>
					<img src={logo} alt='Champawati Saving and Credit Co-operative logo' />
				</Link>
				<div className='hd-name'>
					<h1>चम्पावती बचत तथा ऋण सहकारी संस्था लि.</h1>
					<p className='hd-en'>Champawati Saving &amp; Credit Co-operative Ltd.</p>
					<p className='hd-addr'>Machhapokhari, Kathmandu-16</p>
				</div>
			</div>
		</header>
	);
};

export default Header;
